import React from "react";
import { Switch } from "react-router-dom";
import RedirectWithQuery from "common/Routes/RedirectWithQuery";
import { Security } from "features/settings/Security/Security";
import {
  CHANGE_PASSWORD_SETTINGS_PATH,
  CONFIGURATION_DISABLE_TWO_FA_PATH,
  CONFIGURATION_TWO_FA_PATH,
  PROCESSED_AGREEMENT_SETTINGS_PATH,
  FAILED_AGREEMENT_SETTINGS_PATH,
  CANCELLED_AGREEMENT_SETTINGS_PATH,
  PAID_AGREEMENT_SETTINGS_PATH,
  SECURITY_SETTINGS_PATH,
  BILLING_SETTINGS_PATH,
  PURCHASE_SUBSCRIPTION_SETTINGS_PATH,
  NOTIFICATIONS_SETTINGS_PATH,
  CHANGE_NAME_SETTINGS_PATH,
  CANCEL_SUBSCRIPTION_PATH,
  PURCHASE_API_SLOTS_SETTINGS_PATH,
  CONNECT_EMAIL_SETTINGS_PATH,
  SETTINGS_PATH,
} from "common/constants";
import { ChangePasswordPage } from "features/settings/Security/ChangePasswordPage";
import TwoFAWizard from "features/settings/Security/TwoFA/TwoFAWizard";
import BuySubscription from "features/settings/Subscription/BuySubscription";
import Billing from "features/settings/Billing/Billing";
import PaymentStatus from "features/settings/Subscription/PaymentStatus";
import PrivateRoute from "common/Routes/PrivateRoute";
import { useCheckBillingRedirects } from "utils/hooks/misc";
import NotificationsSettings from "features/settings/Security/NotificationsSettings/NotificationsSettings";
import ChangeNamePage from "features/settings/Security/ChangeNamePage.tsx";
import CancelSubscription from "features/settings/CancelSubscription/CancelSubscription.tsx";
import ApiSlotsWithSummary from "features/settings/Billing/ApiSlots/ApiSlotsWithSummary.tsx";
import ConnectEmailPage from "features/settings/Security/ConnectEmail/ConnectEmailPage.tsx";
import styled from "styled-components";
import { withNewLookSettingsLayout } from "features/settings/NewLook/withNewLookSettingsLayout.tsx";

// With the new look, the settings sections render inside a frame with a
// secondary navigation; with the classic look they render as before.
const SecurityPage = withNewLookSettingsLayout(Security);
const NotificationsPage = withNewLookSettingsLayout(NotificationsSettings);
const BillingPage = withNewLookSettingsLayout(Billing);
const ChangePassword = withNewLookSettingsLayout(ChangePasswordPage);
const ChangeName = withNewLookSettingsLayout(ChangeNamePage);
const ConnectEmail = withNewLookSettingsLayout(ConnectEmailPage);
const TwoFA = withNewLookSettingsLayout(TwoFAWizard);

const Settings = () => {
  const billingRedirect = useCheckBillingRedirects();
  if (billingRedirect) return billingRedirect;

  return (
    <Wrapper>
      <Switch>
        {/* "/settings" alone has no page: open the first section. */}
        <RedirectWithQuery
          exact
          from={SETTINGS_PATH}
          to={SECURITY_SETTINGS_PATH}
        />
        <PrivateRoute
          path={CHANGE_PASSWORD_SETTINGS_PATH}
          component={ChangePassword}
        />
        <PrivateRoute path={CHANGE_NAME_SETTINGS_PATH} component={ChangeName} />
        <PrivateRoute
          path={CONNECT_EMAIL_SETTINGS_PATH}
          component={ConnectEmail}
        />
        <PrivateRoute
          path={[
            PROCESSED_AGREEMENT_SETTINGS_PATH,
            PAID_AGREEMENT_SETTINGS_PATH,
            FAILED_AGREEMENT_SETTINGS_PATH,
            CANCELLED_AGREEMENT_SETTINGS_PATH,
          ]}
          component={PaymentStatus}
        />
        <PrivateRoute
          path={[CONFIGURATION_TWO_FA_PATH, CONFIGURATION_DISABLE_TWO_FA_PATH]}
          component={TwoFA}
        />
        <PrivateRoute
          path={PURCHASE_SUBSCRIPTION_SETTINGS_PATH}
          component={BuySubscription}
        />
        <PrivateRoute
          path={PURCHASE_API_SLOTS_SETTINGS_PATH}
          component={ApiSlotsWithSummary}
        />
        <PrivateRoute
          path={CANCEL_SUBSCRIPTION_PATH}
          component={CancelSubscription}
        />
        <PrivateRoute path={BILLING_SETTINGS_PATH} component={BillingPage} />
        <PrivateRoute
          path={NOTIFICATIONS_SETTINGS_PATH}
          component={NotificationsPage}
        />
        <PrivateRoute component={SecurityPage} path={SECURITY_SETTINGS_PATH} />
      </Switch>
    </Wrapper>
  );
};

export default Settings;

const Wrapper = styled.div`
  z-index: 1;
  width: 100%;
  height: 100%;
`;
